<ng-container *ngIf="pageMode">
  <div #content>
    <ng-container *ngIf="true then template_type_slide"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="!pageMode">
  <ion-header>
    <ion-toolbar color="light">
      <ion-buttons slot="start">
        <ion-button (click)="dismissModal()">
          <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        <app-offline-indicator></app-offline-indicator>
        {{ 'BLAST.template.list' | translate }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button class="ion-margin" expand="block" (click)="presentBlastTemplateManageModal()">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content color="light" #content>
    <ng-container *ngIf="true then template_type_list"></ng-container>
  </ion-content>
</ng-container>

<ng-template #template_type_list>
  <div class="ion-padding">
    <ion-text class="font-12 font-med">
      {{ replaceEventType('BLAST.template.msg.select_template' | translate) }}
    </ion-text>
  </div>
  <div class="full-width-height viewport-div" *ngIf="templateTypeList?.length">
    <cdk-virtual-scroll-viewport [itemSize]="44" *ngIf="templateTypeList?.length">
      <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
        <ion-item class="item" *cdkVirtualFor="let templateType of templateTypeList; trackBy: trackByFn; let i = index;" (click)="presentBlastTemplateManageModal(templateType)" detail lines="none">
          <ion-text class="font-12">
            <ng-container *ngIf="!templateType?.custom">{{ 'LIST.blast_type.' + templateType.value | translate }}</ng-container>
            <ng-container *ngIf="templateType?.custom">{{ templateType.value }}</ng-container>
          </ion-text>
        </ion-item>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </div>
</ng-template>

<ng-template #template_type_slide>
  <ng-container *ngIf="templateTypeList?.length">
    <div class="template-slide-title line-1 ion-padding-horizontal">
      <ion-text class="font-12 font-med">
        {{ replaceEventType('BLAST.template.msg.select_template' | translate) }}
      </ion-text>
    </div>
    <swiper-container [slidesPerView]="slidePerView">
      <ng-container *ngFor="let templateType of templateTypeList">
        <swiper-slide class="center ion-text-center" *ngIf="templateType.value">
          <ion-card class="type-div background-transparent ion-no-margin ion-text-center center" (click)="presentBlastTemplateManageModal(templateType)" button>
            <div class="type-frame vertical-center" [class]="templateType?.custom ? 'type-frame-custom' : ''">
              <ng-container *ngIf="templateType?.custom">
                <ion-img class="type-img" src="./assets/wedding/icon/general/envelope-outline.svg"></ion-img>
              </ng-container>
              <ng-container *ngIf="!templateType?.custom">
                <ion-img class="full-width-height" src="./assets/wedding/img/blast/template/qrcode.webp" *ngIf="templateType.value === 'qrcode'"></ion-img>
                <ion-img class="full-width-height" src="./assets/wedding/img/blast/template/thanks.webp" *ngIf="templateType.value === 'thank_you'"></ion-img>
                <ion-img class="full-width-height" src="./assets/wedding/img/blast/template/reminder.webp" *ngIf="templateType.value === 'reminder'"></ion-img>
              </ng-container>
            </div>
            <ion-text class="font-10">
              <ng-container *ngIf="!templateType?.custom">{{ 'LIST.blast_type.' + templateType.value | translate }}</ng-container>
              <ng-container *ngIf="templateType?.custom">{{ templateType.value }}</ng-container>
            </ion-text>
          </ion-card>
        </swiper-slide>
      </ng-container>
    </swiper-container>
  </ng-container>
</ng-template>